// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"74dfc5c7","455":"0599f67a","977":"b05f2a01"}[chunkId] + ".chunk.js";
};